import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import Logos from '../assets/logoContainer.svg';
import Profiles from '../assets/profileContainer.svg';

export const TrustedSection: React.FC = () => {
  return (
    <>
      <style>{`
        .trusted-section {
          position: relative;
          width: 100%;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          box-sizing: border-box;
        }

        @media (min-width: 992px) {
          .trusted-section {
            min-height: 100vh;
            min-height: 100dvh;
          }
        }

        .trusted-section__content {
          position: relative;
          z-index: 1;
          flex: 1 1 auto;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          min-height: 0;
          padding-top: clamp(24px, 4dvh, 40px);
          padding-bottom: clamp(24px, 4dvh, 80px);
        }

        @media (max-width: 991.98px) {
          .trusted-section__content {
            flex: 0 0 auto;
            padding-top: 40px;
            padding-bottom: 60px;
          }
        }
      `}</style>

      <section className="trusted-section" aria-label="Trusted by leading LinkedIn Top Voices">
        <Container fluid className="trusted-section__content">
          <Row className="w-100 justify-content-center">
            <Col
              xs={12}
              md={10}
              lg={9}
              xl={8}
              className="d-flex flex-column align-items-center text-center"
              style={{ gap: 20 }}
            >
              <div
                style={{
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: 500,
                  fontSize: 25,
                  lineHeight: '100%',
                  color: '#FFFFFFF5',
                }}
              >
                Trusted by leading Linkedin Top Voices
              </div>
              <div
                style={{
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: 400,
                  fontSize: 25,
                  lineHeight: '100%',
                  color: '#FFFFFF6B',
                }}
              >
                From leading creators to established enterprises
              </div>
              <Image
                src={Logos}
                alt="Trusted logos"
                className="img-fluid"
                style={{ marginTop: 24, width: '85%' }}
              />
              <Image src={Profiles} alt="Top voices" className="img-fluid" style={{ marginTop: 16 }} />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
